<template>
  <v-card class="execution input-card">
    <div class="tab-bar">
      <v-tabs v-model="tab"
              grow
              show-arrows>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#fieldImages">Field Images</v-tab>
        <v-tab href="#documents">Documents</v-tab>
        <v-tab v-if="this.userRole === 'Admin'" href="#changeOrders">Change Orders</v-tab>
      </v-tabs>
    </div>
    <v-tabs-items v-model="tab">
      <v-tab-item value="fieldImages">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <file-upload uploadType="image" ref="saveImages" step="Execution" imageType="Field Image"></file-upload>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="documents">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <file-upload uploadType="document" ref="saveDocs" step="Execution"></file-upload>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="changeOrders">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col class="image-uploader-wrapper" xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <file-upload uploadType="change" ref="saveDocs" step="Execution"></file-upload>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <div v-if="this.userRole !== 'Sub Foreman'" class="footer">
      <v-container pa-0>
        <v-row>
          <v-col class="spacing-col" cols="2"></v-col>
          <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12" class="btn-wrapper">
            <div v-if="!this.showReset">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn depressed color="accent" class="btn-complete" :disabled="disabled" @click="complete" v-on="on">
                  Complete
                  <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                </v-btn>
              </template>
              <span>Move to next step (Field Complete)</span>
            </v-tooltip>
            </div>

            <div v-if="showReset">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn depressed color="accent" class="btn-reset" @click="reset" v-on="on">
                  Reset
                  <v-icon dark right>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>Reset to this step (Execution)</span>
            </v-tooltip>
            </div>
          </v-col>
          <v-col class="spacing-col" cols="2"></v-col>
        </v-row>
      </v-container>
    </div>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import FileUpload from '@/components/files/FileUpload'
export default {
  name: 'Execution',
  components: {
    FileUpload
  },
  created () {
  },
  data () {
    return {
      tab: 'documents'
    }
  },
  methods: {
    ...mapActions({
      update: 'workOrderTask/updateTask'
    }),
    complete () {
      let updateStatus = this.task
      updateStatus.status = 'FieldComplete'
      delete updateStatus.workOrder
      this.update(updateStatus)
    },
    reset () {
      let updateStatus = this.task
      updateStatus.status = 'Execution'
      delete updateStatus.workOrder
      this.update(updateStatus)
    }
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      userRole: 'user/role',
      step: 'workOrderTask/step'
    }),
    disabled () {
      if (this.task != null && this.task.status === 'Execution') {
        return false
      } else {
        return true
      }
    },
    showReset () {
      if ( this.step > 3) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
  ::placeholder {
    color: rgba(0, 0, 0, 0.87) !important;
  }
  .input-card {
    border: 1px solid #e0e0e0 !important;
    border-radius: 0;
  }
  .input-wrapper {
    min-height: 280px;
    padding: 0;
  }
  .tab-bar {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  .btn-wrapper {
    padding: 0 12px 16px 0 !important;
    margin-bottom: 16px;
  }
  .btn-reset,
  .btn-save,
  .btn-complete {
    float: right;
  }
  .btn-complete {
    color: #fff;
    margin: 0 0 0 16px;
  }
  .btn-reset {
    margin-left: 16px;
  }
  @media only screen and (max-width: 959px) {
    .input-wrapper {
      padding: 0 16px;
    }
    .btn-wrapper {
      padding-right: 28px !important;
    }
    .spacing-col {
      display: none;
    }
  }
  @media only screen and (max-width: 550px) {
    .image-uploader-wrapper {
      padding-bottom: 20px;
    }
  }
  @media only screen and (max-width: 420px) {
    .input-card {
      border-left: none !important;
      border-right: none !important;
      border-radius: 0 !important;
    }
  }
</style>
